import { render, staticRenderFns } from "./ReportSetup.vue?vue&type=template&id=2cda3e89&"
import script from "./ReportSetup.vue?vue&type=script&lang=ts&"
export * from "./ReportSetup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports